export default {
  schedule: {
    date_and_time: 'Data e Hora*',
    number_of_guests: 'Número de Convidados*',
    location: 'Local:',
  },
  personal_information: {
    title: 'Título',
    first_name: 'Nome próprio',
    enter_first_name: 'Introduzir nome próprio',
    last_name: 'Apelido*',
    enter_last_name: 'Introduzir apelido',
    email: 'Email',
    enter_email: 'Introduzir email',
    phone: 'Telefone',
    annotation: 'Anotação',
    enter_annotation: 'Introduzir anotação',
  },
  gender: {
    without_title: 'Sem título',
    male: 'Sr.',
    female: 'Sra.',
  },
  buttons: {
    save: 'Guardar',
  },
  error_messages: {
    invalid_email: 'Introduza um endereço de e-mail válido, sem espaços nem trémas antes do @.',
    invalid_phone_number: 'Número de telefone inválido. Por favor, reveja as suas informações e tente novamente.',
    failed_reservation: 'Falha ao enviar a sua reserva. Por favor, reveja as suas informações e tente novamente.',
    invalid_reservation_day: 'Não aceitamos reservas neste dia.',
    no_tables_available: 'Lamentamos, não temos mais mesas disponíveis.',
    please_enter_guests: 'Por favor, indique o número de convidados.',
    please_select_time: 'Por favor, selecione uma hora.',
    please_select_last_name: 'Por favor, indique o apelido',
  },
  success_messages: {
    reservation_saved: 'Reserva guardada com sucesso',
  },
};
